﻿const styleRegistry = new Map();

export function loadStyleOnce(href, options = {}) {
    const {
        attrs = {},
        insertBefore = '#vendor-css-anchor'
    } = options;

    if (!href) {
        return Promise.reject(new Error("Style href is required."));
    }

    if (styleRegistry.has(href)) {
        return styleRegistry.get(href);
    }

    const existing = document.querySelector(`link[rel="stylesheet"][href="${href}"]`);
    if (existing) {
        const resolved = Promise.resolve(existing);
        styleRegistry.set(href, resolved);
        return resolved;
    }

    const promise = new Promise((resolve, reject) => {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = href;

        Object.entries(attrs).forEach(([key, value]) => {
            link.setAttribute(key, value);
        });

        link.onload = () => resolve(link);
        link.onerror = () => reject(new Error(`Failed to load stylesheet: ${href}`));

        if (insertBefore) {
            const ref = document.querySelector(insertBefore);
            if (ref && ref.parentNode) {
                ref.parentNode.insertBefore(link, ref);
            } else {
                document.head.appendChild(link);
            }
        } else {
            document.head.appendChild(link);
        }
    });

    styleRegistry.set(href, promise);
    return promise;
}